export class HumanDesignReportError extends Error {
  constructor(public error: string) {
    super(error);
  }
}
